import moment from 'moment-timezone';
import { Timezone } from '../model/timezone';

// Preserve the default used by Device Monitor when firmware omits its timezone.
export const DEFAULT_DEVICE_TIMEZONE = 'America/New_York';

/** Firmware may report a catalogued POSIX rule or an IANA timezone name. */
export function resolveDeviceTimezone(value: unknown): string {
  const timezone = typeof value === 'string' ? value.trim() : '';
  const entry = Timezone.find(item => item['tz-posix'] === timezone || item.tz === timezone);
  if (entry) return entry.tz;
  if (timezone && moment.tz.zone(timezone)) return timezone;
  return DEFAULT_DEVICE_TIMEZONE;
}

export function deviceTimezoneLabel(value: unknown): string {
  const timezone = resolveDeviceTimezone(value);
  const entry = Timezone.find(item => item['tz-posix'] === value || item.tz === timezone);
  return entry ? entry.name : timezone;
}
